// src/app/services/map-tooltip-helper.service.ts
import * as L from 'leaflet';
import * as turf from '@turf/turf';

function hasTooltipValue(value: unknown): boolean {
  return value !== undefined && value !== null && String(value).trim() !== '';
}

export function attachVesselHoverPopup({
  layer,
  feature,
  feedName,
  map,
  nonVesselFeed,
  helperService,
  nudgeInsideView,
  pickDirection,
  showEeTooltip,
}: {
  layer: any;
  feature: any;
  feedName: string;
  map: L.Map;
  nonVesselFeed: any[];
  helperService: any;
  nudgeInsideView: (latLng: L.LatLng, padding?: number) => L.LatLng;
  pickDirection: (pt: L.Point, threshold: number, padding: { right: number; top: number }) => string;
  showEeTooltip: (lyr: any, direction: 'top' | 'bottom' | 'left' | 'right', content: string, anchor: L.LatLng) => void | L.Tooltip;
}) {
  layer.on('mouseover', (e: L.LeafletMouseEvent) => {
    const hasDepthInfo =
      feature.properties?.depth_class != null ||
      feature.properties?.mean_depth_m != null ||
      feature.properties?.mean_depth != null;
    if (feedName && nonVesselFeed.findIndex((item) => item.name === feedName) !== -1 && !hasDepthInfo) return;
    if (feature.geometry.type === 'Point' || feature.geometry.type === 'MultiPoint') return;

 try {
  const coords = JSON.parse(JSON.stringify(feature.geometry.coordinates));

  let centroid;

  if (feature.geometry.type === 'MultiPolygon') {
    if (Array.isArray(coords?.[0]?.[0])) {
      coords[0][0].push(coords[0][0][0]);
    }
    centroid = turf.centroid(turf.multiPolygon(coords));
  } 
  else if (feature.geometry.type === 'Polygon') {
    if (Array.isArray(coords?.[0])) {
      coords[0].push(coords[0][0]);
    }
    centroid = turf.centroid(turf.polygon(coords));
  } 
  else if (feature.geometry.type === 'LineString') {
    centroid = turf.centroid(turf.lineString(feature.geometry.coordinates));
  } 
  else {
    centroid = turf.centroid(feature as any);
  }

  const centroidCoordinates = centroid.geometry.coordinates;

  const bounds = layer.getBounds();
  const north = bounds.getNorth();
  const west = bounds.getWest();
  const east = bounds.getEast();
  const labelLatLng = L.latLng(north + 0.00003, (west + east) / 2);
  const area = feature.properties?.area;
  const unit = feature.properties?.unit;
  const timestamp = feature.properties?.Timestamp ?? feature.properties?.timestamp;
  const seaState = feature.properties?.sea_state;
  const vesselLength =
    feature.properties?.vessel_length ||
    feature.properties?.vessel_len ||
    feature.properties?.length;
  const vehicleLength = feature.properties?.length_m;

  const content = `
    <div class="custom-tooltip-content">
      ${hasTooltipValue(feature.properties?.confidence) ? `<b>Confidence:</b> ${feature.properties?.confidence}<br>` : ''}
      ${vehicleLength != null ? `<b>Length:</b> ${vehicleLength} m<br>` : ''}
      ${hasTooltipValue(vesselLength) ? `<b>Vessel length:</b> ${vesselLength}<br>` : ''}
      ${hasTooltipValue(timestamp) ? `<b>Timestamp:</b> ${timestamp}<br>` : ''}
      ${hasTooltipValue(seaState) ? `<b>Sea state:</b> ${seaState}<br>` : ''}
      ${(feature.properties?.mean_depth_m != null || feature.properties?.mean_depth != null) ? `<b>Mean Depth :</b> ${feature.properties.mean_depth_m ?? feature.properties.mean_depth}<br>` : ''}

      <b>Lng:</b> ${centroidCoordinates[0]}<br>
      <b>Lat:</b> ${centroidCoordinates[1]}<br>
      ${hasTooltipValue(area) ? `<b>Area:</b> ${area}${unit ? ` ${unit}` : ''}<br>` : ''}
    </div>`;

  const { anchor } = helperService.computeAnchorAndLocation(feature, labelLatLng);
  const safeAnchor = nudgeInsideView(anchor, 80);
  const pt = map.latLngToContainerPoint(safeAnchor);
  const dir = pickDirection(pt, 120, { right: 100, top: 60 });

  showEeTooltip(layer, dir as 'top' | 'bottom' | 'left' | 'right', content, safeAnchor);

} catch (err) {
}
  });
}
